"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var LocationsModel = /** @class */ (function () {
    function LocationsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/locations",
            UPDATE: APPURL + "/api/v1/locations",
            CREATE: APPURL + "/api/v1/locations",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResult = this.cacheResult.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    LocationsModel.prototype.extract = function (result) {
        return result.data;
    };
    LocationsModel.prototype.cacheResults = function (result) {
        return this.extract(result);
    };
    LocationsModel.prototype.cacheResult = function (result) {
        return result;
    };
    LocationsModel.prototype.getUserLocations = function (user) {
        var user_id;
        if (typeof user !== "object") {
            user_id = user;
        }
        else {
            user_id = user.id;
        }
        return this.$http.get(this.URLS.FETCH).then(function (response) {
            return response.data.filter(function (location) {
                return location.user_id === user_id;
            });
        });
    };
    LocationsModel.prototype.geocode = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/geocode", { data: data })
            .then(this.extract);
    };
    LocationsModel.prototype.getLocationByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.extract);
    };
    LocationsModel.prototype.getLocations = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    LocationsModel.prototype.createLocation = function (location) {
        return this.$http
            .post(this.URLS.FETCH, location)
            .then(this.cacheResults);
    };
    LocationsModel.prototype.editLocation = function (location) {
        return this.$http
            .put(this.URLS.FETCH + "/" + location.id, location)
            .then(this.cacheResults);
    };
    LocationsModel.prototype.deleteLocation = function (location) {
        var id = typeof location === "number" ? location : location.id;
        return this.$http
            .delete(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    LocationsModel.prototype.disableLocation = function (location) {
        return this.$http
            .patch(this.URLS.FETCH + "/" + location.id + "/disable", { id: location.id, status: "Disabled" })
            .then(this.cacheResults);
    };
    LocationsModel.prototype.activateLocation = function (location) {
        return this.$http
            .patch(this.URLS.FETCH + "/" + location.id + "/activate", { id: location.id, status: "Enabled" })
            .then(this.cacheResults);
    };
    LocationsModel.prototype.createClassroom = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/" + data.location_id + "/classrooms", data)
            .then(this.cacheResults);
    };
    LocationsModel.prototype.editClassroom = function (data) {
        return this.$http
            .put(this.URLS.FETCH + "/" + data.location_id + "/classrooms/" + data.id, data)
            .then(this.cacheResults);
    };
    LocationsModel.prototype.getTravelDistanceBetween = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/traveldistance", data)
            .then(this.cacheResults);
    };
    LocationsModel.prototype.getZones = function (location_id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + location_id + "/zones")
            .then(this.cacheResults);
    };
    LocationsModel.prototype.placePickupLocation = function (data) {
        return this.$http
            .get(this.APPURL + "/api/v1/pickuplocations/place?" + (0, queryString_1.toQueryString)(data))
            .then(function (response) {
            return response.data;
        });
    };
    return LocationsModel;
}());
LocationsModel.$inject = ["$http", "APPURL"];
exports.default = LocationsModel;
